import { Badge } from '@/components/ui/badge';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { Star, Zap, Crown } from 'lucide-react';

interface MentorTierBadgeProps {
  tier: 'free' | 'pro';
  platformFeeExempt?: boolean;
  size?: 'sm' | 'md' | 'lg';
  showTooltip?: boolean;
  className?: string;
  mentorName?: string;
}

export const MentorTierBadge = ({ 
  tier, 
  platformFeeExempt = false, 
  size = 'md',
  showTooltip = true,
  className = '',
  mentorName = ''
}: MentorTierBadgeProps) => {
  // Only show badge for platform fee exempt (admin) accounts
  // Don't show pro tier badges since pro tier doesn't exist yet
  if (!platformFeeExempt) {
    return null;
  }

  const getIcon = () => {
    if (platformFeeExempt) return <Crown className="h-3 w-3" />;
    return (
      <div className="w-5 h-5 bg-red-500 rounded-full flex items-center justify-center">
        <Star className="h-3 w-3 text-white fill-white" />
      </div>
    );
  };

  const getBadgeContent = () => {
    if (platformFeeExempt) {
      return (
        <div className="flex items-center gap-1">
          {getIcon()}
          <span>Admin</span>
        </div>
      );
    }
    
    return (
      <div className="flex items-center gap-1">
        {getIcon()}
      </div>
    );
  };

  const getVariant = (): "default" | "secondary" | "destructive" | "outline" => {
    return 'default';
  };

  const getTooltipContent = () => {
    if (platformFeeExempt) {
      return "Admin account - No platform fees";
    }
    
    return "Pro Tier - No platform fees, priority listing, advanced analytics";
  };

  const badge = (
    <Badge variant={getVariant()} className={`${size === 'sm' ? 'text-xs' : ''} ${className}`}>
      {getBadgeContent()}
    </Badge>
  );

  if (!showTooltip) {
    return badge;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          {badge}
        </TooltipTrigger>
        <TooltipContent>
          <p>{getTooltipContent()}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};